<template>
  <div style=" background-color:#00f; opacity:0; min-height: 100%; ">
 <form action="https://h5pay.jd.com/jdpay/saveOrder" method="post" id="batchForm">
		<input type="button" onclick="autosubmit()" value="点这提交">
		<input type="hidden" name="version"   :value="this.g_jdpayList.version"><br>
		<input type="hidden" name="merchant"   :value="this.g_jdpayList.merchant"><br>
		<input type="hidden" name="device" :value="this.g_jdpayList.device"><br>
		<input type="hidden" name="tradeNum" :value="this.g_jdpayList.tradeNum"><br>
		<input type="hidden" name="tradeName" :value="this.g_jdpayList.tradeName"><br>
		<input type="hidden" name="tradeDesc" :value="this.g_jdpayList.tradeDesc"><br> 
		<input type="hidden" name="tradeTime" :value="this.g_jdpayList.tradeTime"><br>
		<input type="hidden" name="amount" :value="this.g_jdpayList.amount"><br>
		<input type="hidden" name="currency" :value="this.g_jdpayList.currency"><br>
		<input type="hidden" name="note" :value="this.g_jdpayList.note"><br>
		<input type="hidden" name="callbackUrl" :value="this.g_jdpayList.callbackUrl"><br> 
		<input type="hidden" name="notifyUrl" :value="this.g_jdpayList.notifyUrl"><br>
		<input type="hidden" name="ip" :value="this.g_jdpayList.ip"><br>
		<input type="hidden" name="userType" :value="this.g_jdpayList.userType"><br>
		<input type="hidden" name="userId" :value="this.g_jdpayList.userId"><br>
		<input type="hidden" name="expireTime" :value="this.g_jdpayList.expireTime"><br> 
		<input type="hidden" name="orderType" :value="this.g_jdpayList.orderType"><br>
		<input type="hidden" name="industryCategoryCode" :value="this.g_jdpayList.industryCategoryCode"><br>
		<input type="hidden" name="specCardNo" :value="this.g_jdpayList.specCardNo"><br>
		<input type="hidden" name="specId" :value="this.g_jdpayList.specId"><br>
		<input type="hidden" name="specName" :value="this.g_jdpayList.specName"><br>
		<input type="hidden" name="payChannel" value=""><br>
		<input type="hidden" name="sign" :value="this.g_jdpayList.sign"><br>
		<input type="hidden" name="cert" value=""><br>
		<input type="hidden" name="vendorId" value=""><br>
		<input type="hidden" name="goodsInfo" value=""><br>
		<input type="hidden" name="orderGoodsNum" value=""><br>
		<input type="hidden" name="receiverInfo" value=""><br>
		<input type="hidden" name="termInfo" value=""><br>
	  <input type="hidden" name="riskInfo" value=""><br>
    <input type="hidden" name="installmentNum" value=""><br>
	  <input type="hidden" name="preProduct" value=""><br>
	</form>

  </div>
</template>







<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../api";

export default {
  computed: {
    ...mapGetters(["g_UserInfo", "g_PayOrder","g_jdpayList"])
  },
  data() {
    return {
      NowUser: "",
      version: "",
      JdpayInfo: {},
    };
  },
  activated() {
        //this.version= this.g_jdpayList.version;
         console.log(this.g_jdpayList)
       
      //this.JdpayInfo=this.g_jdpayList;
		    document.getElementById("batchForm").submit();
  },

  methods: {
    ...mapMutations(["setG_PayOrder", "setG_UserInfo"]),

    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 3700);

    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    // 弹出层  end
  }
};
</script>
 

<style lang="less" scoped>
@import "../../assets/theme.less";
 .page {
  height: auto;
  overflow: hidden;
}
 
</style>


// WEBPACK FOOTER //
// Jdpay.vue?beef0ff6